import styled from 'styled-components';

export const Summary = styled.div`
  width: 100%;
`;

export const EmptyLineup = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px 0px;
  h3 {
    margin-top: 23px;
    color: #757575;
  }
`;

export const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  margin-top: 8px;
  background-color: #fff;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  height: 53px;
  border-bottom: 1px solid #f2f2f2;
  h2 {
    margin-left: 15px;
    font-size: 14px;
    color: #151515;
  }
`;

export const Tab = styled.div`
  box-sizing: border-box;
  display: flex;
  // height: 74px;
  width: 100%;
  margin-top: 8px;
  padding: 20px 15px;
  background-color: #ffffff;
`;

export const Button = styled.button`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 34px;
  border: solid 1px #78818e;
  background-color: #ffffff;
  font-size: 13px;
  &.active {
    background-color: #78818e;
    color: #ffffff;
  }
`;

export const ContentsHeader = styled.div`
  display: flex;
  align-items: center;
  height: 36px;
  border-bottom: 1px solid #f2f2f2;

  & > span {
    display: flex;
    font-size: 11px;
  }
`;

export const BattingSlot = styled.span`
  box-sizing: border-box;
  position: relative;
  justify-content: center;
  padding-left: 13px;
  width: 40px;
  min-width: 40px;
  text-align: center;

  img {
    position: absolute;
    height: 10px;
    width: 7px;
    top: 3px;
    right: -2px;
  }
`;

export const Player = styled.span`
  box-sizing: border-box;
  justify-content: flex-start;
  width: 119px;
  min-width: 119px;
  padding-left: 15px;
`;

export const Row = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 50px;
  min-width: 50px;
  background-color: #f6f6f6;
  text-align: center;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  &:first-child {
    border-left: 1px solid #f2f2f2;
  }
`;

export const EarnedRunAverage = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-width: 60px;
  width: 60px;
  background-color: #f6f6f6;
  text-align: center;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  &:first-child {
    border-left: 1px solid #f2f2f2;
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  overflow-x: scroll;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  height: 36px;
  border-bottom: 1px solid #f2f2f2;
  &.noneBorder {
    border: none;
  }
  span {
    font-size: 13px;
  }
`;

export const Empty = styled.li`
  display: flex;
  justify-content: center;
  height: 100%;
  border-bottom: none;
`;
